<section class="head-wrapper container-fluid d-flex flex-column">
  <div class="container text-container d-flex justify-content-center">
    <div class="title-wrapper d-flex flex-column align-items-center my-auto">
      <div class="title d-flex flex-column">
        <div class="d-lg-none">
          Let’s <strong class="under-img">demystify </strong>AI consultancy.
        </div>
        <div class="d-none d-lg-block">
          <div>Let’s <strong class="under-img">demystify </strong></div>
          <div dir="rtl"><span dir="ltr">AI consultancy.</span></div>
        </div>
      </div>
      <div class="sub-title text-lg-center">
        We remove the complexity from enterprise AI. Tell us your business
        challenge and we’ll build a solution that fits your needs – with a focus
        on cost and speed.
      </div>
    </div>
  </div>
  <div [ngClass]="{ 'd-none d-lg-block' : !isFromConsultancyPage }" class="h3-lg text container">
    /Here’s how we work.
  </div>
  <div class="mobile-card-wrapper d-lg-none" appViewport (inViewport)="onInViewport($event)">
    <div class="detail-card">
      <div class="dotted"></div>
      <div class="card-body d-flex flex-column h-100">
        <div class="card-title secondary-text h3-lg">
          {{ selectedCard.index }}
        </div>
        <div class="card-subtitle h5-lg">{{ selectedCard.name }}</div>
          <ul class="card-text p-0 body-4-sm flex-grow-1">
              @for(item of selectedCard.descriptionList; track $index){
              <li>{{item}}</li>
              }
          </ul>
      </div>
    </div>
    <div class="d-flex gap-3">
      @for(card of cardArr; track $index){
      <div (click)="startFromCard($index)" [ngClass]="
          selectedCard.name === card.name ? 'btn-cta-hover-text active' : ''
        " class="card-selector">
        <div class="h5-sm">{{ card.index }}.</div>
        <div class="mb-3">{{ card.name }}</div>
        @if($index === currentCardIndex && showCard){
        <ngb-progressbar [value]="progressValue" height="4px"></ngb-progressbar>
        }
      </div>
      }
    </div>
  </div>
  <div class="w-100 d-none d-lg-block">
      <div class="card-wrapper d-flex position-relative" appViewport (inViewport)="onInViewport($event)">
          @for(card of cardArr; track $index){
          <app-card
                  (cardClick)="startFromCard($index); hoverCardIndex = -1"
                  (hoverIn)="hoverIn($index)"
                  (hoverOut)="hoverOut($index)"
                  [isTabChange]="isChromeTabChanged"
                  [cardObj]="card"
                  [class.align-below]="$index % 2 !== 0"
                  [showDetailCard]="hoverCardIndex !== -1 ? false : $index === currentCardIndex && showCard"
                  [showHoverCard]="$index === hoverCardIndex && showCard"
                  class="card-component"
          ></app-card>
          }
          <div class="position-absolute dotted"></div>
      </div>
  </div>
  <div class="start-btn-wrapper" [ngClass]="{'d-none d-lg-flex' : isFromConsultancyPage}">
    <button (click)="openContactModal()" class="start-btn btn rounded-pill align-items-center btn-lg">
      talk to us
    </button>
  </div>
</section>
